import { Link } from "react-router-dom";
import { HOME } from "../constants/testIds";
import { BUSINESS } from "../constants/business";
import { COMPANY } from "../data/company";

const SHOP_LINKS = [
  ["Keyboards", "/collections/keyboards"],
  ["Mice", "/collections/mice"],
  ["Mousepads", "/collections/mousepads"],
  ["Keycaps", "/collections/keycaps"],
  ["Audio", "/collections/audio"],
  ["Switches", "/collections/switches"],
  ["Accessories", "/collections/accessories"],
  ["PCB Modules", "/collections/pcb-modules"],
  ["Best Sellers", "/collections/best-sellers"],
  ["Drops", "/drops"],
  ["Hall Effect", "/collections/hall-effect"],
];

const SUPPORT_LINKS = [
  ["About", "/about"],
  ["Operator Lab", "/operator-lab"],
  ["Contact", "/contact"],
  ["Shipping & Returns", "/shipping-returns"],
  ["Pre-Order Policy", "/preorder-policy"],
  ["FAQ", "/faq"],
  ["Track Order", "/track-order"],
  ["Account & Orders", "/account/index"],
  ["Warranty & RMA", "/warranty"],
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
];

// [12] Footer — canvas bg, 1px divider top, 80/40px vertical padding.
export default function Footer() {
  return (
    <footer
      data-testid={HOME.footer}
      className="bg-[#0A0A0A] text-white border-t border-[#1F1F1F]"
    >
      <div className="mx-auto max-w-[1440px] px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div data-testid={HOME.footerCompanyColumn}>
            <div className="flex items-center gap-2 mb-3">
              <div className="font-display text-[24px] leading-none">LOADOUT</div>
            </div>
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A] mt-6 mb-3">
              COMPANY
            </div>
            <ul className="space-y-2 font-sans text-[13px] text-white/80">
              {COMPANY.support_email && (
                <li data-testid={HOME.footerCompanySupportEmail}>
                  <a href={`mailto:${COMPANY.support_email}`} className="hover:text-[#FF9F1C] transition-colors">
                    {COMPANY.support_email}
                  </a>
                </li>
              )}
              {COMPANY.support_hours && (
                <li data-testid={HOME.footerCompanySupportHours} className="text-[#8A8A8A]">
                  {COMPANY.support_hours}
                </li>
              )}
              {COMPANY.response_promise && (
                <li data-testid={HOME.footerCompanyResponsePromise} className="text-[#8A8A8A]">
                  Response {COMPANY.response_promise}
                </li>
              )}
              {COMPANY.gstin && (
                <li data-testid={HOME.footerCompanyGstin} className="text-[#8A8A8A] font-mono text-[12px]">
                  {COMPANY.legal_name} · GSTIN {COMPANY.gstin}
                  <Link
                    to="/contact#business-legal"
                    data-testid="footer-business-legal-link"
                    className="block mt-1 text-[#FF9F1C] hover:underline"
                  >
                    Business & legal info →
                  </Link>
                </li>
              )}
              {COMPANY.cin && (
                <li data-testid={HOME.footerCompanyCin} className="text-[#8A8A8A]">CIN {COMPANY.cin}</li>
              )}
              {COMPANY.registered_address && (
                <li data-testid={HOME.footerCompanyAddress} className="text-[#8A8A8A]">
                  {COMPANY.registered_address}
                </li>
              )}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A] mb-4">
              SHOP
            </div>
            <ul className="space-y-2">
              {SHOP_LINKS.map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="font-sans text-[14px] text-white hover:text-[#FF9F1C] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A] mb-4">
              SUPPORT
            </div>
            <ul className="space-y-2">
              {SUPPORT_LINKS.map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="font-sans text-[14px] text-white hover:text-[#FF9F1C] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A] mb-4">
              CONNECT
            </div>
            <ul className="space-y-2">
              <li>
                <a href={BUSINESS.instagram} target="_blank" rel="noreferrer noopener" className="font-sans text-[14px] text-white hover:text-[#FF9F1C] transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href={BUSINESS.discord} target="_blank" rel="noreferrer noopener" className="font-sans text-[14px] text-white hover:text-[#FF9F1C] transition-colors">
                  Discord
                </a>
              </li>
              <li>
                <a href={BUSINESS.whatsappUrl} target="_blank" rel="noreferrer noopener" className="font-sans text-[14px] text-white hover:text-[#FF9F1C] transition-colors">
                  WhatsApp {BUSINESS.whatsapp}
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="font-sans text-[14px] text-white hover:text-[#FF9F1C] transition-colors">
                  {BUSINESS.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-[#1F1F1F] pt-6 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <div className="font-sans text-[12px] text-[#8A8A8A] max-w-[900px]">
            © 2026 {BUSINESS.entity}. Operated from {BUSINESS.address}.
          </div>
          <div className="flex gap-5 flex-wrap">
            <a href="/privacy" className="font-sans text-[12px] text-[#8A8A8A] hover:text-[#FF9F1C] transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="font-sans text-[12px] text-[#8A8A8A] hover:text-[#FF9F1C] transition-colors">
              Terms of Service
            </a>
            <a href="/cookies" data-testid="footer-cookies-link" className="font-sans text-[12px] text-[#8A8A8A] hover:text-[#FF9F1C] transition-colors">
              Cookies Information
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
